import React from "react";


const About = () =>{
      return(
        <>
        
   {/* <!-- About us start  --> */}

<div class="container my-5 pt-5" id="about">
    <div class="Aboutus">
        <h2 class="text-center display-4 pt-3">About Us</h2>
        <hr class="w-25 mx-auto"/>
        <p class="text-center">little information</p>
    </div>
    <div class="row my-5">
     <div class="col-xxl-3 col-lg-3 col-md-6 col-sm-12 text-center my-3">
         <div class="row">
             <div class="col-xxl-3 col-lg-3 col-md-3 col-sm-3 text-center">
                 <figure><i class="fa-3x fas fa-users"></i></figure>
             </div>
             <div class="col-xxl-8 col-lg-8 col-md-8 col-sm-8">
                 <div class="d-flex flex-column">
                     <h5 class="">Who We Are ?</h5>
                     <p>Awesome Create Developer. 
                     </p>

                 </div>

             </div>
         </div>
     </div>
     <div class="col-xxl-3 col-lg-3 col-md-6 col-sm-12 text-center my-3">
         <div class="row">
             <div class="col-xxl-3 col-lg-3 col-md-3 col-sm-3 text-center">
                 <figure><i class="fa-3x fas fa-laptop-code"></i></figure>
             </div>
             <div class="col-xxl-8 col-lg-8 col-md-8 col-sm-8">
                 <div class="d-flex flex-column">
                     <h5 class="">What We Do ?</h5>
                     <p>Create Awesome programming app. 
                     </p>

                 </div>

             </div>
         </div>
     </div>
     <div class="col-xxl-3 col-lg-3 col-md-6 col-sm-12 text-center my-3">
         <div class="row">
             <div class="col-xxl-3 col-lg-3 col-md-3 col-sm-3 text-center">
                 <figure><i class="fa-3x fab fa-squarespace"></i></figure>
             </div>
             <div class="col-xxl-8 col-lg-8 col-md-8 col-sm-8">
                 <div class="d-flex flex-column">
                     <h5 class="">Why We Do It ?</h5>
                     <p>Learing Course for Awesome create. 
                     </p>

                 </div>

             </div>
         </div>
     </div>
     <div class="col-xxl-3 col-lg-3 col-md-6 col-sm-12 text-center my-3">
         <div class="row">
             <div class="col-xxl-3 col-lg-3 col-md-3 col-sm-3 text-center ">
                 <figure><i class="fa-3x fas fa-users"></i></figure>
             </div>
             <div class="col-xxl-8 col-lg-8 col-md-8 col-sm-8">
                 <div class="d-flex flex-column">
                     <h5 class="">Since When ?</h5>
                     <p> Create Awesome Website from 2018. 
                     </p>

                 </div>

             </div>
         </div>
     </div>
    </div>

    
</div>

{/* <!-- About us end  --> */}
        </>
      );
};
export default About;